import React, { useEffect, useState } from "react";
import "./BlogView.scss";
import { useParams } from "react-router-dom";
import ShareButton from "../ShareButton/ShareButton";
import Tags from "../Tags/Tags";
import DOMPurify from "dompurify";
import { useSelector } from "react-redux";
import { selectBlogByPath, selectAllImages } from "../../selectors.js";
import { Helmet } from "react-helmet-async";
import { FaExpandAlt } from "react-icons/fa";

const BlogView = (props) => {
  const [popupImage, setPopupImage] = useState(null); // State for popup image

  const handleImageClick = (imageSrc) => {
    setPopupImage(imageSrc);
  };

  const closePopup = () => {
    setPopupImage(null);
  };
  const { theme } = props;
  const images = useSelector(selectAllImages);

  const { blogPath } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const selectedBlog = useSelector((state) =>
    selectBlogByPath(state, blogPath)
  );
  const imgPath = images?.find((img) => img.key === selectedBlog.image);
  return (
    <div className="blogView">
      <Helmet>
        <title>{selectedBlog.title}</title>
        <meta name="description" content={selectedBlog.content} />
        <meta name="keywords" content={selectedBlog.tags.join(", ")} />
        <meta property="og:title" content={selectedBlog.title} />
        <meta property="og:description" content={selectedBlog.content} />
        <link
          rel="canonical"
          href={`https://tldrblogs.com/blogs/${blogPath}`}
        />
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: selectedBlog.title,
          description: selectedBlog.content,
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": `https://tldrblogs.com/blogs/${blogPath}`,
          },
          keywords: selectedBlog.tags.join(", "),
        })}
      </script>
      <aside className="shareAside">
        <ShareButton theme={theme} className="blogShare" />
      </aside>
      <section className="header">
        <div
          className="background-image"
          style={{
            backgroundImage: `url(${imgPath?.src})`,
          }}
        />
        <div className="overlay">
          <Tags tags={selectedBlog.tags} />
          <h1 className="blogTitle">{selectedBlog.title}</h1>
          <div className="blogDescp">{selectedBlog.content}</div>
        </div>
      </section>
      <section className="mainContent">
        {selectedBlog.blogDetail.map((blog, index) => {
          const sanitizedHTML = DOMPurify.sanitize(blog);
          const innerImage = images?.find(
            (img) => img.key === selectedBlog.detailImages?.[index]?.imageKey
          );
          const imageCaption =
            selectedBlog.detailImages?.[index]?.caption || "";
          return (
            <div className="blogDetail">
              <div
                key={index}
                dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
              />
              {innerImage && (
                <div className="imageContainer">
                <div className="imageOverlay">
                  <span className="expandIcon" onClick={() => handleImageClick(innerImage.src)}>
                    <FaExpandAlt />
                  </span>
                </div>
                <img
                  src={innerImage.src}
                  alt={imageCaption}
                />
                {imageCaption && <div className="imageCaption">{imageCaption}</div>}
              </div>
              )}

              {popupImage && (
                <div className="imagePopup" onClick={closePopup}>
                  <img src={popupImage} alt="Expanded View" />
                </div>
              )}
            </div>
          );
        })}
      </section>
    </div>
  );
};

export default BlogView;
